import React from 'react';
import PropTypes from 'prop-types';
import {
  Container, makeStyles, Typography, lighten,
} from '@material-ui/core';
import { AppState } from '../../state/MyStateProvider';
import Dashboard3Drawers from '../dashboard-3-drawers/Dashboard3Drawers';
import MyAvatar from '../../widgets/avatar/MyAvatar';
import { APP_STATE_ACTION_TYPE_USER } from '../../state/seed-states';
import SeedAuthenticationRepository from '../../repository/SeedAuthenticationRepository';
import seedDrawerRoutes from '../../route/seed-drawer-routes';
import { drawerRoutesPropTypes, dashboard3DrawersIconsPropTypes } from '../dashboard-3-drawers/d3d-prop-types';
import seedLogo from '../../images/logo.svg';
import { seedDashboard3DrawersIcons } from '../../icon/seed-icons';

const useStyles = makeStyles((theme) => ({
  banner: {
    backgroundColor: () => (theme.palette.type === 'light'
      ? lighten(theme.palette.primary.main, 0.8) : lighten(theme.palette.primary.main, 0.2)),
    height: `${200 - (theme.spacing(2) * 2)}px`,
    display: 'flex',
    alignItems: 'flex-end',
    padding: theme.spacing(2),
  },
  titleContainer: {
    paddingLeft: theme.spacing(2),
    overflow: 'hidden',
  },
  title: {
    display: '-webkit-box',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    overflow: 'hidden',
  },
  spacer: {
    flexGrow: 1,
  },
}));

const defaultUserPropTypes = {
  name: '',
  username: '',
  email: '',
  avatar: '',
  createdAt: new Date(),
};

const SeedProfilePage = (props) => {
  const {
    AuthenticationRepository,
    drawerRoutes,
    isLoading,
    applicationName,
    logo,
    icons,
  } = props;
  const classes = useStyles();
  const { state } = React.useContext(AppState);
  const userToken = state[APP_STATE_ACTION_TYPE_USER];
  const { avatar: userState } = userToken;
  const [user] = React.useState(userState || defaultUserPropTypes);

  return (
    <Dashboard3Drawers
      AuthenticationRepository={AuthenticationRepository}
      titleId="seed.profile.title"
      applicationName={applicationName}
      logo={logo}
      icons={icons}
      routes={drawerRoutes}
      isLoading={isLoading}
      useBackButton
      usePaddingContent={false}
    >
      <Container className={classes.banner}>
        <MyAvatar
          size={60}
          alt={user.title}
          name={user.title}
        />
        <div className={classes.titleContainer}>
          <Typography className={classes.title} variant="h5" color="textPrimary">
            {user.title}
          </Typography>
          <Typography className={classes.title} variant="body2" color="textSecondary">
            {user.subtitle}
          </Typography>
        </div>
        <div className={classes.spacer} />
      </Container>
    </Dashboard3Drawers>
  );
};

SeedProfilePage.propTypes = {
  isLoading: PropTypes.bool,
  AuthenticationRepository: PropTypes.func,
  drawerRoutes: drawerRoutesPropTypes,
  applicationName: PropTypes.string,
  logo: PropTypes.string,
  icons: dashboard3DrawersIconsPropTypes,
};

SeedProfilePage.defaultProps = {
  isLoading: false,
  AuthenticationRepository: SeedAuthenticationRepository,
  drawerRoutes: seedDrawerRoutes,
  applicationName: 'react-seed',
  logo: seedLogo,
  icons: seedDashboard3DrawersIcons,
};

export default SeedProfilePage;
